type StoryIconProps = React.SVGProps<SVGSVGElement>

export const StoryIcon = (props: StoryIconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props} // ⭐ 把所有 props 传给 <svg>
  >
    <path
      opacity="0.7"
      d="M5.75 4.0791C6.40085 4.16713 7.03361 4.42519 7.5752 4.8584L7.65918 4.92578C7.71635 4.97152 7.74999 5.04104 7.75 5.11426V11.5508C7.74986 11.7311 7.54122 11.8314 7.40039 11.7188C6.14317 10.713 4.35683 10.713 3.09961 11.7188C2.95878 11.8314 2.75014 11.7311 2.75 11.5508V5.22168C2.75008 5.08042 2.81449 4.94665 2.9248 4.8584C3.18204 4.65264 3.45955 4.48531 3.75 4.35742V6.49805L4.75 5.49805L5.75 6.49805V4.0791ZM8.4248 4.8584C9.78422 3.77102 11.7158 3.77102 13.0752 4.8584C13.1855 4.94665 13.2499 5.08042 13.25 5.22168V11.5508C13.2499 11.7311 13.0412 11.8314 12.9004 11.7188C11.6432 10.713 9.85683 10.713 8.59961 11.7188C8.45878 11.8314 8.25014 11.7311 8.25 11.5508V5.11426C8.25001 5.04104 8.28365 4.97152 8.34082 4.92578L8.4248 4.8584Z"
      fill="white"
    />
  </svg>
)
export default StoryIcon
